const middleware = {}

middleware['asset-signing'] = require('../middleware/asset-signing.js')
middleware['asset-signing'] = middleware['asset-signing'].default || middleware['asset-signing']

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['commit-header'] = require('../middleware/commit-header.js')
middleware['commit-header'] = middleware['commit-header'].default || middleware['commit-header']

middleware['redirect-to-folio'] = require('../middleware/redirect-to-folio.js')
middleware['redirect-to-folio'] = middleware['redirect-to-folio'].default || middleware['redirect-to-folio']

middleware['route-product'] = require('../middleware/route-product.js')
middleware['route-product'] = middleware['route-product'].default || middleware['route-product']

middleware['security-headers'] = require('../middleware/security-headers.js')
middleware['security-headers'] = middleware['security-headers'].default || middleware['security-headers']

middleware['show-locale-banner'] = require('../middleware/show-locale-banner.js')
middleware['show-locale-banner'] = middleware['show-locale-banner'].default || middleware['show-locale-banner']

export default middleware
